import React, { useContext } from "react";
import { loadStripe } from "@stripe/stripe-js";
import { Elements } from "@stripe/react-stripe-js";
import CheckoutForm from "./CheckoutForm";
import { CartContext } from "../context/CartContext";

// Initialize Stripe
const stripePromise = loadStripe("pk_live_51RJWTaGb7gg2VKZUq0FQVLsfinuBMckTYcgYIxSGYvOBk8FxxbPbCGLL8rfr7eS3lx4hUXjTPFW2NWvLeTcqmgq100pwsblqnd");

const PaymentPage = () => {
  const { cart } = useContext(CartContext);

  const totalPrice = cart.reduce((total, item) => total + item.price * item.quantity, 0);
const finalPrice = parseFloat(localStorage.getItem("finalPrice") || totalPrice);
  if (cart.length === 0) {
    return <p>Your cart is empty. <a href="/cart">Go back to cart</a></p>;
  }

  return (
    <section className="section-space">
      <div className="container">
        <div className="row justify-content-center">
          <div className="col-lg-5">
          <div className="payment-box">
          <div className="main-h"><h2 className="m-heading">Payment</h2></div>
          <p>Total Amount: £{finalPrice.toFixed(2)}</p>
          <Elements stripe={stripePromise}>
            <CheckoutForm totalPrice={finalPrice} />
          </Elements>
          </div>
          </div>
        </div>
      
      </div>
    </section>
  );
};

export default PaymentPage;
